export const GET_ALL_RACKS = "GET_ALL_RACKS";
export const GET_ALL_RACKS_SUCCESS = "GET_ALL_RACKS_SUCCESS";
export const GET_ALL_RACKS_ERROR = "GET_ALL_RACKS_ERROR";
